import React from "react";
import {translate} from "react-i18next";

const Agilar2 = ({t}) => {
    return (
        <div className="history-tab">
            <h4 className="header">{t('about.history.agilar2.header')}</h4>
            <p>{t('about.history.agilar2.line1')}</p>
            <p>{t('about.history.agilar2.line2')}</p>
        </div>
    )
}

export default translate('common')(Agilar2);